export class PunchListItem {
    id!: string
    indexId!: number
    job!: string
    item?: number | null
    location!: string
    scope!: string
    priority?: number | null
    projectMateNumber!: string
    description!: string
    responsibleFirmId?: number | null
    contactId?: number | null
    vanConResponsibleUserId?: string | null
    done!: boolean
    notes!: string
    completionToken?: string | null
    completionComment?: string | null
    imageUrls: string[] = []
    imageFileNames: string[] = []
}
